import { notification } from 'antd';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import * as yup from 'yup'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../../Services/axiosCommon';
import Dasboard from '../../../Components/Icons/Dasboard';
import {
    BackButton,
    CancelButton,
    SubmitButton,
  } from "../../../Components/Utils/Buttons";
import CustomImgUpload from '../../../Components/Utils/CustomImgUpload';

import Breadcrumb from '../../../Components/Utils/Breadcrumb';
import { NuDate, NuInput, NuMobileNumber, NuSelect } from '../../../Components/Utils/Input';
import MultiSelect from '../../../Components/Utils/MultiSelect';
import FormikSelectTwo from '../../../Components/Utils/Select';
import useEditFormData from '../../../Components/Hooks/useEditFormData';
import { CountryMIN } from '../../../assets/CountryMini';
import UseCatSubCatDropDown from '../../../Components/Hooks/useCategoryDropDown';
import useFetchMataData from '../../../Components/Hooks/useFetchMataData';

function EditEmployee() {
    const {officeId} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.data;
    console.log(data,'dddyh');
    
  const from = location.state.from;
  const { value: clientPosition } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "clientPosition"
  );
    const [projectList, setProjectList] = useState([]);
    const { Oncancel, editFormData, isLoading } =
    useEditFormData();
    const [image, setImage] = useState({ preview: "", raw: "" });
  const [api, contextHolder] = notification.useNotification();
  const [createNew, setCreateNew] = useState({
    email: data?.email || "",
    mobileNo: data?.mobileNo || "",
    name: data?.name || "",
    branchId: officeId,
    gender: data?.gender || "",
    dob: data?.dob || "",
    dateOfJoin: data?.dateOfJoin || "",
    position: data?.position || "",
    emergencyName: data?.emergencyName || "",
    emergencyRelationship: data?.emergencyRelationship || "",
    emergencyMobileNo: data?.emergencyMobileNo || "",
    location: data?.location || "",
    state: data?.state || "",
    city: data?.city || "",
    pincode: data?.pincode || "",
    country: data?.country || "",
    address1: data?.address1 || "",
    address2: data?.address2 || "",
    dateOfRelieving: data?.dateOfRelieving || "",
    country_code:data?.country_code||"",
    currentProject: data?.currentProject || [],
    type: data?.type,
    category: data?.category || "",
    nationalId: data?.nationalId || "",
    nationalIdExpiryDate: data?.nationalIdExpiryDate || "",
    passportNumber: data?.passportNumber || "",
    passportExpiryDate: data?.passportExpiryDate  || "",
    projectWorked: data?.projectWorked||[],

   });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
     mobileNo: yup
                 .string()
                 .matches(/^\d+$/, "Phone number must contain only digits")
                 .min(9, "Phone number must be at least 9 digits")
                 .max(11, "Phone number must be at most 11 digits")
                 .required("Phone number is required"),
         email: yup.string().required("Email is required!"),
         name: yup.string().required("Name  is required!"),
         type: yup.string().required("Type  is required!"),
        //  currentProject: yup.string().required("Current Project  is required!"),
         gender: yup.string().required("Gender  is required!"),
   
         }),
         onSubmit: async (value, { resetForm }) => {
          const withBranchId = {
            ...value,
            branch: officeId,
          }
      

          let formData = new FormData();
          formData.append("json_data", JSON.stringify(withBranchId));
          formData.append("employeeImage", image.raw);
          editFormData(
            `/employees/${data.employeeId}`,
            formData,
            resetForm,
            from,
          );
        },
  });
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  const handleImageRemove = ()=>{
    setImage({
      preview: "",
      raw: "",
    });
  }


  function getAllProject() {
    axiosInstance.get(`/DropDown/${officeId}/getAllProjects`).then((res) => {
      let allProject = res.data?.data;
      let finalData = [];
      res.data?.data &&
        allProject.forEach((i) => {
          let x = {
            value: i.projId,
            label: i.projName,
          };
          finalData.push(x);
        });
      setProjectList(finalData);
    }).catch((error) => {
      console.error("Error fetching projects:", error);
        
    });
  }

  useEffect(()=>{
    getAllProject()
  },[])


  function getHOF() {
    let cDate = new Date();
    return cDate.setFullYear(cDate.getFullYear() - 18);
  }
  const handleDeleteImg = () => {
    setImage({
      preview: "",
      raw: "",
    });
    setCreateNew(prevState => ({ ...createNew, userImage: "" }))
    formik.values.userImage = ''
  }
  const { category: itemsCategory, subCategory: itemsSubCategory } =
  UseCatSubCatDropDown(
    "/category/ItemCategory",
    "ItemCategory",
    formik?.values?.category
  );
  return (
    <div className=" w-full h-full py-2 px-4 ">
        {/* <div className=""> */}
        <div className="md:flex justify-end w-full">
        {/* <Breadcrumb
          items={[
            // { name: "Sales" },

            {
              name: "Employee",
              link: `/main/${officeId}/employees`,
            },

            { name: "Edit" },
          ]}
        /> */}
           
            <BackButton/>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
          <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Personal Info :
              </p>
            </div>
            <CustomImgUpload
              borderStyle="dashed"
              handleChange={handleChangeImg}
              label={"User Profile"}
              preview={image.preview || createNew.employeeImage || ""}
              removeFunction={handleDeleteImg}
            />
            <NuInput
              type="text"
              label="Name"
              placeholder="Enter Name"
              formik={formik}
              name="name"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="mobileNo"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="DOB"
              placeholder="DOB"
              formik={formik}
              name="dob"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Gender"
              Options={[
                { value: "M", label: "Male" },
                { value: "F", label: "Female" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="gender"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Type"
              Options={[
                { value: '1', label: "Own" },
                { value: '2', label: "Rental" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="type"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
           <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/3"
              // isRequired={true}
            />
             <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Employee Roll :
              </p>
            </div>
            <FormikSelectTwo
              type="text"
              label="Position"
              placeholder="Choose"
              Options={clientPosition}
              formik={formik}
              name="position"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <MultiSelect
              label="Assigned Project"
              Options={projectList}
              formik={formik}
              placeholder="Choose"
              isRequired={true}
              name="currentProject"
              width="w-full md:w-1/3 md:-mt-2"
            />
            {/* <MultiSelect
              label="Assigned Project"
              Options={projectList}
              formik={formik}
              placeholder="Choose"
              // isRequired={true}
              name="projectWorked"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
              Emergency Info :
              </p>
            </div>
            <NuInput
              type="text"
              label="Emergency Name"
              placeholder="Enter Name"
              formik={formik}
              name="emergencyName"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              // nunCode="countryCode"
              label="Emergency Mobile No"
              placeholder="Emergency Mobile No"
              formik={formik}
              name="emergencyMobileNo"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Relationship"
              Options={[
                { value: "Father", label: "Father" },
                { value: "Mother", label: "Mother" },
                { value: "Brother", label: "Brother" },
                { value: "Sister", label: "Sister" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="emergencyRelationship"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />
            <NuDate
              label="Date Of Join"
              placeholder="Date Of Join"
              formik={formik}
              name="dateOfJoin"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Date Of Relieving"
              placeholder="Date Of Relieving"
              formik={formik}
              name="dateOfRelieving"
              
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              label="National Id"
              placeholder="National Id"
              formik={formik}
              name="nationalId"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />
            <NuDate
              label="National-Id Expiry Date"
              formik={formik}
              name="nationalIdExpiryDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
             
              label="Passport Number"
              placeholder="Passport Number"
              formik={formik}
              name="passportNumber"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />
            <NuDate
              label="Passport Expiry Date"
              formik={formik}
              name="passportExpiryDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
           
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Address :
              </p>
            </div>
            <NuInput
              type="text"
              label="Street Address Line 1"
              placeholder="Street Address Line 1"
              formik={formik}
              name="address1"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />

            <NuInput
              type="text"
              label="Street Address Line 2"
              placeholder="Street Address Line 2"
              formik={formik}
              name="address2"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />

            <NuInput
              type="text"
              label="City"
              placeholder="Enter City"
              formik={formik}
              name="city"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <NuInput
              type="text"
              label="State"
              placeholder="Enter State"
              formik={formik}
              name="state"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              type="text"
              label="Country"
              placeholder="Country"
              Options={CountryMIN}
              formik={formik}
              name="country"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
              PortalTarget={true}
            />

            <NuInput
              type="number"
              label="Zip Code"
              placeholder="Type Here"
              formik={formik}
              name="pincode"
              width="w-full md:w-1/3 md:-mt-2"
            />
            {/* <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Choose Status"
              Options={[
                {
                    value: 0,
                    label: "In-Active",
                  },
                {
                  value: 1,
                  label: "Active",
                },
              ]}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
              <div className="md:flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
            </form>
    </div>
  )
}

export default EditEmployee